import { Components, Theme } from '@mui/material'

export const MuiMenu: Components<Theme>['MuiMenu'] = {
  styleOverrides: {
    root: {
      '& .MuiPaper-root': {
        boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.08)',
      },
    },
  },
}
